import { render, staticRenderFns } from "./PaymentChoiceItem.vue?vue&type=template&id=3f3cbf1c&scoped=true"
import script from "./PaymentChoiceItem.vue?vue&type=script&lang=js"
export * from "./PaymentChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentChoiceItem.vue?vue&type=style&index=0&id=3f3cbf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3cbf1c",
  null
  
)

export default component.exports